import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageStateService {
  // Signals for shared page state
  public securePrintLevel = signal<string | null>(null);
  public printJobsPageType = signal<string>('PrintJobsPage');

  constructor() {}

  setSecurePrintLevel(level: string): void {
    this.securePrintLevel.set(level);
  }

  setPrintJobsPageType(pageType: string): void {
    this.printJobsPageType.set(pageType);
  }
}
